import { BAND_PATHS } from "Bands/router";
import { useBandRoute } from "Bands/utils";
import { copy } from "shared/assets";
import { Plus } from "shared/assets/icons";
import { Icon } from "shared/styles";

import { StyledAddEventButton } from "./styles";

export const AddEventButton = () => {
  const { pushRoute } = useBandRoute();

  return (
    <StyledAddEventButton
      onClick={() => pushRoute(BAND_PATHS.CREATE_BAND_EVENT)}
      data-testid="add_event_button"
    >
      <Icon as={Plus} />
      <span>{copy.event.create.button}</span>
    </StyledAddEventButton>
  );
};
